import {
  SET_NOT_READY_TO_SELL,
  SET_NOT_READY_TO_SELL_ERROR,
  CLEAR_NOT_READY_TO_SELL,
} from "../../constants/action-types";

const initState = {
  data: [],
};
export const notReadyToSell = (state = initState, action) => {
  switch (action.type) {
    case SET_NOT_READY_TO_SELL:
      return { ...state, data: action.payload };
    case SET_NOT_READY_TO_SELL_ERROR:
      return { ...state, error: action.payload };
    case CLEAR_NOT_READY_TO_SELL:
      return { ...state, data: [] };
    default:
      return state;
  }
};
